import { LastMileDeliveryPlaceConfig } from '../../../domain/types/configs/company/LastMileCarrierDeliveryPlace';

export const lastMileDeliveryPlaceConfig: LastMileDeliveryPlaceConfig = {
    lastMileDeliveryPlace: [],
    showAll: true
};